import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription, combineLatestWith, of, mergeMap, tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { JSONAtaObject } from 'src/app/features/shared/helper-classes';

/* data storage interface for ngrx */
import { DataStorage } from 'src/app/features/data-stores/data-storage.interface';

import * as lodash from 'lodash';

// prettier-ignore
// #region customCode: page-component-ts__package-import__end

// #endregion customCode: page-component-ts__package-import__end

@Component({
  selector: 'liife-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.scss']
})
export class BlankComponent implements OnInit, OnDestroy {

  // prettier-ignore
    // #region customCode: page-component-ts__ui-page-component-class__start
  
  // #endregion customCode: page-component-ts__ui-page-component-class__start

  

  /* state subscriptions */
  subscriptions: Subscription[];

  /* visibility condition variables */
  

  constructor(
    private store: Store<DataStorage>
  ) {
    // prettier-ignore
    // #region customCode: page-component-ts__constructor__start
    
    // #endregion customCode: page-component-ts__constructor__start

    // prettier-ignore
    // #region customCode: page-component-ts__constructor__end
    
    // #endregion customCode: page-component-ts__constructor__end
  }

  ngOnInit(): void {
    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-init__start
    
    // #endregion customCode: page-component-ts__ui-page-on-init__start

    this.subscribeToData();
    this.subscribeToDataSelectors();

    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-init__end
    
    // #endregion customCode: page-component-ts__ui-page-on-init__end
  }

  ngOnDestroy(): void {
    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-destroy__start
    
    // #endregion customCode: page-component-ts__ui-page-on-destroy__start
    
    this.subscriptions?.forEach(subscription => subscription.unsubscribe());

    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-destroy__end
    
    // #endregion customCode: page-component-ts__ui-page-on-destroy__end
  }

  subscribeToData() {
    this.subscriptions = [
      ];
  }

  subscribeToDataSelectors() {
    const dataSelectors = [
      
    ];
    this.subscriptions.push(...dataSelectors);
  }

  // prettier-ignore
    // #region customCode: page-component-ts__ui-page-component-class__end
    
    // #endregion customCode: page-component-ts__ui-page-component-class__end
}
